<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.28975 9.43296H20.7102M10.1663 4L8.33252 9.43296L12 19.8461L15.6674 9.43296L13.8337 4M12.5635 19.6311L20.7773 9.89671C21.082 9.53577 21.0663 9.31158 20.7773 8.96921L16.8043 4.26065C16.636 4.06126 16.4935 4 16.2407 4H7.7592C7.50647 4 7.36395 4.06126 7.19571 4.26065L3.22262 8.96921C2.93367 9.31163 2.91801 9.53571 3.22262 9.89671L11.4365 19.6311C11.8373 20.1062 12.1346 20.1395 12.5635 19.6311Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
